<style lang="scss" scoped>
  .dragger {
    height: 6px;
    cursor: ns-resize
  }
  .no-dragger {
    display: none;
  }

  .msg {
    font-size: 16px;
    border: 1px solid var(--color-neutral);
    border-radius: 5px;
    margin-bottom: 10px;
  }

  .TVChartContainer {
    height: 508px;
    border-radius: 5px 5px 0 0;
    overflow: hidden;
    background-color: var(--color-chart);

    &.full {
      height: 100%;
    }
  }

  .resizing {
    pointer-events: none;
  }

  .tv-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .ticker {
    border-radius: 0 0 5px 5px;
    border-top: 1px solid var(--color-chart-border);
  }
</style>

<template>
  <div style="height: 100%">
    <Placeholder v-if="!$store.state.sys.exchangesLoaded || !$store.state.sys.tradeExchange.ExchId" :text="$text.tr(!$store.state.sys.exchangesLoaded ? 'Загрузка' : 'Ожидание добавления биржи') + '...'" />
    <div class="tv-wrapper" style="margin-left: 0px;" v-show="$store.state.sys.exchangesLoaded && $store.state.sys.tradeExchange.ExchId && showChart && $store.state.trade.showTV">
      <div class="TVChartContainer" :class="{ resizing, full }" :id="containerId"></div>
      <SymbolTicker class="ticker" mode="terminal" />
      <div :class="{'no-dragger': noDragger }" class="dragger" @mousedown="initResize" style="margin-top: -8px;"><img src="@/assets/dragger2.png" /></div>
    </div>
    <div v-if="$store.state.sys.exchangesLoaded && $store.state.sys.tradeExchange.ExchId && !showChart && $store.state.trade.showTV" class="msg" style="margin-top: 15px; padding: 10px">
      <span style="font-size: 17px">{{ $text.tr('График для') }} {{exchName}} {{ $text.tr('находится в разработке') }}</span>
    </div>
  </div>
</template>

<script>
// import TradingView from '@/util/tv'
import { sha256 } from 'js-sha256'
import constants from '@/util/constants'
import Datafeed from '@/services/datafeed/'
import { widget } from '@/lib/charting_library'
import Decimal from 'decimal.js'
import Vue from 'vue'
import Api from '@/util/api'
import SlimApi from '@/util/slimapi'
import SlimApis from '@/util/slimapis'
import terminal from '@/services/terminal'
import Data from '@/util/data'
import $store from '@/store/index'
import MobileDetect from 'mobile-detect'
import Util from '@/util/util'
import global from '@/util/global'
import SymbolTicker from '@/components/common/SymbolTicker'
import Placeholder from '@/components/common/Placeholder'

const TVRETRY_DELAY = 1000
const TVRETRY_COUNT = 3

const state = {
  tvWidget: null,
  soLines: [],
  soTrailingLines: [],
  triggerLines: [],
  buyLine: null,
  slLine: null,
  tpLines: [],
  averageBuyLine: null,
  liquidationLine: null,
  arrows: [],
  filledArrows: [],
  filledOrders: [],
  filledSlims: [],
  sleepTimeout: null,
  sleepResetTimeout: null
}

export default {
  name: 'TV2',
  components: {
    SymbolTicker,
    Placeholder
  },
  props: {
    full: Boolean,
    noDragger: Boolean
  },
  data: function () {
    return {
      containerId: 'tv_chart_container',
      element: null,
      resizing: false,
      prevState: '',
      lastSample: Date.now()
    }
  },

  watch: {
    '$store.state.sys.email' (email) {
      if (this.$store.state.trade.showTV === true && this.showChart && this.$store.state.trade.tvLoading === false) {
        this.$store.state.trade.tvLoading = true
        this.startChart()
      }
    },
    '$store.state.trade.lastTrade' (newts) {
      if (state.buyLine) {
        state.buyLine.remove()
        state.buyLine = null
      }
    },
    '$store.state.trade.showArrors' () {
      // console.log('show arrors changed')
      if (this.storetrade.showArrors) {
        const trade = this.storetrade.editTrade
        if (trade) {
          this.cleanFilledArrows()
          if (trade.Orders) {
            trade.Orders.forEach(order => {
              this.addFilledOrderArrowShape(order)
            })
          }
        } else {
          this.drawSymbolExeOrdersArrows()
        }
      } else {
        this.cleanFilledArrows()
      }
    },
    '$store.state.trades.data.Trades' () {
      // console.log('trades changed')
      if (!this.storetrade.editTrade) {
        this.drawSymbolTPsAndOrders2()
      }
    },
    '$store.state.trade.setTradeSymbolNeeded' () {
      if (!this.$store.state.trade.tvEnabled) {
        return
      }
      !this.$store.state.trade.showOrders && this.cleanLines()
    },
    '$store.state.calls.addnewtp' () {
      this.addNewTradeTpLine()
    },
    '$store.state.trade.side' (side) {
      // if (side === 'S') {
      //   cleanLines () {
      // }
      // console.log('editTradeId', this.$store.state.trade.editTradeId)
      if (!this.$store.state.trade.editTradeId && this.storetrade.type !== 'market') {
        this.cleanBuyLine()
        this.addBuyLine()
      }
    },
    // '$store.state.sltpModal' (showSltp) {
    //   this.resizing = showSltp
    // },
    '$store.state.trade.editTrade.Sltp.SlPrice' (newSlPrice) {
      const trade = this.$store.state.trade.editTrade
      // console.log('trade edited:', this.$store.state.trade.editTrade)
      if (trade) {
        if (trade.Sltp) {
          if (state.slLine) {
            state.slLine.remove()
            state.slLine = null
          }
          if (trade.Sltp.SlPrice && trade.Sltp.SlPrice !== '0') {
            // this.formSlLine(trade.Price, trade.Sltp.SlPrice)

            // console.log('add sl line for trade:', trade)
            this.addTradeSlLine(trade)
          }
        }
      }
    },
    '$store.state.trade.slprice' () {
      this.formSlLine(this.$store.state.trade.price, this.$store.state.trade.slprice)
    },
    '$store.state.trade.tpsteps' () {
      if (!this.$store.state.trade.editTradeId) {
        // console.log('tpsteps changed', this.$store.state.trade.tpsteps)
        this.formTpLines()
      }
    },
    '$store.state.trade.editTrade.tpsteps': {
      handler (tpsteps) {
        // console.log('editTrade tpsteps changed')
        setTimeout(() => {
          this.formTradeTpLines()
        }, 10)
      },
      deep: true
    },
    '$store.state.trade.editTrade.so': {
      handler (so) {
        // console.log('editTrade so changed')
        setTimeout(() => {
          this.formSOLines()
          if (this.$store.state.trade.editTrade) {
            if (this.$store.state.trade.editTrade.Sltp && this.$store.state.trade.editTrade.Sltp.SlPrice !== '0') {
              this.addTradeSlLine(this.$store.state.trade.editTrade)
            }
            if (this.$store.state.trade.editTrade.tpsteps && this.$store.state.trade.editTrade.tpsteps.length > 0) {
              this.formTradeTpLines()
            }
          }
        }, 10)
      },
      deep: true
    },
    '$store.state.trade.price' (newPrice) {
      if (state.buyLine) {
        // if ($store.state.sys.tradeExchange.ExchId === 'BYF') {
        //   var filt = $store.state.data.symbolsfilter[$store.state.trade.symbol]
        //   console.log(JSON.stringify(filt))
        //   newPrice = Util.truncateWithStep(newPrice, filt.PriceMin).toString()
        //   console.log(newPrice)
        // }
        state.buyLine.setPrice(parseFloat(newPrice))
      }
    },
    '$store.state.trade.editTrade.Price' (newPrice) {
      if (state.averageBuyLine) {
        state.averageBuyLine.setPrice(parseFloat(newPrice))
      }
    },
    '$store.state.trade.type': function (value) {
      if (value === 'market') {
        this.setMarketBuyLine()
        this.resetSlTpLines()
      } else if (!state.buyLine) {
        this.addBuyLine()
      }
    },
    '$store.state.trade.qty': function (newQty) {
      if (newQty && newQty !== '0' && !this.storetrade.editTrade) {
        if (state.buyLine) {
          state.buyLine.setQuantity(newQty + ' ' + this.storetrade.pair[0])
        } else {
          this.addBuyLine()
        }
      }

      if (this.storetrade.type === 'market') {
        this.setMarketBuyLine()
      }
    },
    '$store.state.trade.editTrade.Info.LiquidationPrice': function (liqPrice) {
      // console.log('LiquidationPrice updated:', liqPrice)
      if (parseFloat(liqPrice) !== 0) {
        this.addLiquidationPriceLine(liqPrice)
      }
    },
    // '$store.state.sys.tradeExchange': function () {
    //   this.cleanLines()
    // },
    '$store.state.trade.editTrade': function (trade) {
      // console.log('editTrade:', trade?.Id)
      this.cleanLines()
      if (trade) {
        // if (!state.tvWidget) {
        if (!this.$store.state.trade.showTV) {
          return
        }
        // clean old arrows
        // state.arrows.forEach(arrow => arrow.remove())
        // state.arrows = []

        trade.v = 2

        let waiting = 10
        if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
          waiting = 1000
        }

        if (trade.Status === 'ORDSUBMIT' && trade.QtyNofee === '0' && trade.IntOrderId.length > 0) {
          setTimeout(() => {
            this.addTradeBuyLine(trade)
          }, waiting)
        } else if (trade.Status !== 'ORDSUBMIT' && trade.Status !== 'COND') {
          setTimeout(() => {
            this.addAverageBuyLine(trade)
          }, waiting)
        }
        // console.log('trade.Buys:', trade.Buys)
        setTimeout(() => {
          this.cleanFilledArrows()
          if (trade.Orders && this.storetrade.showArrors === true) {
            trade.Orders.forEach(order => {
              this.addFilledOrderArrowShape(order)
            })
          }
        }, 10)
        if (trade.Sltp) {
          if (trade.Sltp.TradeId) {
            trade.v = 1
          }
          if (trade.Sltp.SlPrice && parseFloat(trade.Sltp.SlPrice) > 0) {
            // this.formSlLine(trade.Price, trade.Sltp.SlPrice)
            // console.log('add sl line for trade:', trade)
            this.addTradeSlLine(trade)
          }
          if (trade.Sltp.Steps) {
            Vue.set(trade, 'tpsteps', trade.Sltp.Steps.Steps)
          } else if ((!trade.tpsteps || trade.tpsteps.length === 0) && trade.Sltp &&
            parseFloat(trade.Sltp.TpPrice) > 0) {
            const step = {
              Price: trade.Sltp.TpPrice,
              Pct: '100',
              Qty: trade.Qty,
              Status: 'ACT'
            }
            Vue.set(trade, 'tpsteps', [step])
          }
          this.formTradeTpLines()
        }

        // console.log('trade:', trade)
        // console.log('v:', trade.v)
        if (trade.Tpsteps) {
          // eslint-disable-next-line no-return-assign
          // trade.Tpsteps.forEach(tpstep => tpstep.Status = 'ACT')
          // console.log('tpsteps:', trade.Tpsteps)
          Vue.set(trade, 'tpsteps', trade.Tpsteps)
        }
        this.formSOLines()

        if ((trade.ExchId === 'BIF' || trade.ExchId === 'FTX' || trade.ExchId === 'OKX' || trade.ExchId === 'BYF' || trade.ExchId === 'GEF') && trade.Info && parseFloat(trade.Info.LiquidationPrice) !== 0) {
          this.addLiquidationPriceLine(trade.Info.LiquidationPrice)
        }
      } else {
        this.cleanFilledArrows()
        this.drawSymbolTPsAndOrders()
        this.drawSymbolExeOrdersArrows()
      }
    },
    // 'tradeExchOrSymbolChanged': function () {
    '$store.state.sys.chartInfo': function (chartInfo) {
      // console.log('chartInfo:', JSON.stringify(chartInfo))
      // console.log('symbol or exchange changed')
      if (this.$store.state.trade.tvEnabled) {
        this.cleanLines()
        if (!this.storetrade.editTrade) {
          this.drawSymbolTPsAndOrders()
          this.drawSymbolExeOrdersArrows()
        }
      }
    },
    '$store.state.trade.showTV': function () {
      if (this.$store.state.trade.showTV === true && this.showChart && this.$route.name === 'terminal') {
        if (this.$store.state.trade.tvEnabled) {
          this.createChart()
        } else {
          this.$store.state.trade.tvLoading = true
          this.createChart()
          // Api.get('user/tvdata?mode=term&cmd=load&token=' + this.$store.state.sys.token, { transformResponse: res => res })
          //   .then(res => {
          //     this.createChart(res.data)
          //   })
          //   .catch(error => {
          //     console.log(error)
          //   })
        }
      }
    },
    '$route' (to, from) {
      if (to.name === 'terminal' && !state.tvWidget && this.$store.state.trade.showTV === true &&
          (this.$store.state.sys.tradeExchange.ExchId === 'BIN' || this.$store.state.sys.tradeExchange.ExchId === 'BIM')) {
        // console.log('new chart needed')
        this.createChart()
      }
      if (to.name === 'terminal' && state.tvWidget && this.$store.state.trade.showTV === true &&
        this.$store.state.sys.tradeExchange.ExchId === 'BIN') {
        // console.log('chart exists. reloading lines')

        // this.addButtons()

        // if (state.slLine) {
        //   state.slLine.remove()
        //   state.slLine = null
        // }
        // if (this.tpLine) {
        //   this.tpLine.remove()
        //   this.tpLine = null
        // }
      }
    }
    // '$store.state.texchange': function (exId) {
    //   // this.changeSymbol()
    //   if (this.$store.state.showTV === true) {
    //     if (exId.exchId === 'BIN') {
    //       this.showChart = true
    //       this.createChart()
    //     } else {
    //       this.showChart = false
    //     }
    //   }
    // }
  },
  computed: {
    tradeExchOrSymbolChanged () {
      // console.log('tradeExchOrSymbolChanged')
      // eslint-disable-next-line
      let a = this.$store.state.sys.tradeExchange.Id
      // eslint-disable-next-line
      let b = this.$store.state.trade.symbol

      return Date.now()
    },
    exchName () {
      return constants.exchangeTVIds[this.$store.state.sys.tradeExchange.ExchId]
    },
    chartSymbol () {
      return constants.exchangeTVIds[this.$store.state.sys.chartInfo.ExchId] + ':' + this.$store.state.sys.chartInfo.TradeSymbol.replace('_', '/')
    },
    showChart () {
      const validEids = ['BIN', 'BIM', 'BIF', 'HUO', 'EXM', 'FTX', 'OKX', 'BYF', 'BYB', 'GET', 'GEF']
      if (validEids.includes(this.$store.state.sys.chartInfo.ExchId)) {
      // if (this.$store.state.sys.tradeExchange.ExchId === 'BIN' || this.$store.state.sys.tradeExchange.ExchId === 'BIM' || this.$store.state.sys.tradeExchange.ExchId === 'HUO') {
        return true
      }
      return false
    },
    storetrade () {
      return this.$store.state.trade
    }
  },

  methods: {
    setMarketBuyLine () {
      this.$store.state.trade.price = this.$store.state.sys.lastPrice

      if (state.buyLine) {
        state.buyLine.setPrice(this.$store.state.sys.lastPrice)
      } else {
        this.addBuyLine()
      }

      this.cleanBuyLine()
    },
    startChart () {
      this.createChart()
      // Api.get('user/tvdata?mode=term&cmd=load&token=' + this.$store.state.sys.token, { transformResponse: res => res })
      //   .then(res => {
      //     this.createChart(res.data)
      //   })
      //   .catch(error => {
      //     console.log(error)
      //   })
    },
    addSOTrailingLine (so) {
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart() || !so.Trail) {
        return
      }
      const ref = this
      const color = '#8E65E6'

      const sideText = this.storetrade.editTrade.Side === 'B' ? 'TRAILING BUY ' : 'TRAILING SELL '

      const buyLine = state.tvWidget.chart().createOrderLine()
        .setText(sideText)
        .setPrice(parseFloat(so.Price))
        .setQuantity(so.Qty + ' ' + this.storetrade.editTrade.Symbol.split('_')[0])
        .setLineWidth(2)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
        .onCancel('onCancel called', function (text) {
          this.remove()
          terminal.cancelSO(this.so)
          state.soTrailingLines = state.soTrailingLines.filter(soLine => soLine !== this)
        })
      buyLine.so = so
      state.soTrailingLines.push(buyLine)
      // console.log('so trailing line added', so)
    },
    addLiquidationPriceLine (price) {
      if (state.liquidationLine) {
        state.liquidationLine.remove()
        state.liquidationLine = null
      }
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      const ref = this
      const color = '#FE007E'

      state.liquidationLine = state.tvWidget.chart().createOrderLine()
        .setText(this.$text.tr('ЛИКВИДАЦИЯ'))
        .setQuantity('')
        .setPrice(parseFloat(price))
        .setLineWidth(2)
        .setLineStyle(3)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
      // console.log('liquidation line added')
    },
    addTriggerLine (so) {
      // console.log('addTriggerLine', JSON.stringify(so))
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      const ref = this
      const color = '#0e30cf'
      const sideText = 'TRIGGER'

      const triggerLine = state.tvWidget.chart().createOrderLine()
        .setText(sideText)
        .setPrice(parseFloat(so.Trigger))
        // .setQuantity(so.Qty + ' ' + this.storetrade.editTrade.Symbol.split('_')[0])
        .setQuantity(so.Price)
        .setLineWidth(2)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
        .onMove('onModify called', function (text) {
          const filt = ref.$store.state.data.symbolsfilter[ref.$store.state.trade.editTrade.Symbol]
          let priceDec = 8
          let amountDec = 8
          if (filt) {
            priceDec = filt.PriceDec
            amountDec = parseFloat(filt.PriceDec) + parseFloat(filt.QtyDec)
          }

          // let priceDec = ref.$store.state.data.symbolsfilter[ref.$store.state.trade.editTrade.Symbol].PriceDec
          const trigPrice = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_HALF_UP).toString()
          // var soAmount = new Decimal(this.getPrice()).mul(this.so.Qty).toDP(amountDec, Decimal.ROUND_HALF_UP).toString()

          this.so.Trigger = trigPrice
          // this.triggerLine.Amount = soAmount
          // terminal.sortEditedTradeSO()
        })
        .onCancel('onCancel called', function (text) {
          this.remove()
          this.so.Trigger = '0'
          this.so.Option = 'EMPTY'
          // terminal.cancelSO(this.so)
          state.triggerLines = state.triggerLines.filter(soLine => soLine !== this)
        })
      triggerLine.so = so
      state.triggerLines.push(triggerLine)
    },
    returnSlPct (trade) {
      let slPct = new Decimal(0)
      if (trade.so && trade.so.length > 0) {
        let totQty = new Decimal(0)
        let totAmount = new Decimal(0)
        if (trade.Status !== 'ORDSUBMIT') {
          totQty = new Decimal(trade.Qty)
          totAmount = new Decimal(trade.Price).mul(trade.Qty)
        }
        trade.so.forEach(so => {
          if (so.Status !== 'EXC') {
            const soQty = terminal.returnDecimalValue(so.Qty)
            const soPrice = terminal.returnDecimalValue(so.Price)
            totQty = totQty.add(soQty)
            const amount = new Decimal(soPrice).mul(soQty)
            totAmount = totAmount.add(amount)
          }
        })
        if (totAmount.equals(0) || totQty.equals(0)) {
          slPct = new Decimal(0)
        } else {
          const avgPrice = totAmount.div(totQty)
          slPct = new Decimal(trade.Sltp.SlPrice).sub(avgPrice).mul(100).div(avgPrice).toDP(1)
        }
      } else {
        slPct = new Decimal(trade.Sltp.SlPrice).sub(trade.Price).mul(100).div(trade.Price).toDP(1)
      }
      if (trade.Side === 'S') {
        slPct = slPct.neg()
      }
      return slPct.toNumber()
    },
    formSOLinesInternal () {
      if (this.storetrade.editTrade && this.storetrade.editTrade.so) {
        // console.log('formSOLines')
        state.soLines.forEach(soLine => {
          soLine.remove()
        })
        state.triggerLines.forEach(trigLine => {
          trigLine.remove()
        })
        state.soTrailingLines.forEach(soTrailLine => {
          soTrailLine.remove()
        })
        state.soLines = []
        state.triggerLines = []
        state.soTrailingLines = []
        this.storetrade.editTrade.so.forEach(so => {
          if (so.Status !== 'EXC') {
            if (so.Trail) {
              this.addSOTrailingLine(so)
            } else {
              this.addSOLine(so)
            }
            if (so.Trigger !== '0' && so.Cond !== true) {
              this.addTriggerLine(so)
            }
          }
        })
      }
    },
    formSOLines (retryCount = 0) {
      try {
        this.formSOLinesInternal()
      } catch (error) {
        // console.log('Error forming SO lines, retrying in 1 second')
        if (retryCount < TVRETRY_COUNT) {
          setTimeout(() => {
            this.formSOLines(retryCount + 1)
          }, TVRETRY_DELAY)
        }
      }
    },
    addSOLine (so) {
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      const ref = this
      const color = '#787bb4'
      const sideText = this.storetrade.editTrade.Side === 'B' ? 'BUY ' : 'SELL '

      const buyLine = state.tvWidget.chart().createOrderLine()
        .setText(sideText)
        .setPrice(parseFloat(so.Price))
        .setQuantity(so.Qty + ' ' + this.storetrade.editTrade.Symbol.split('_')[0])
        .setLineWidth(2)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
        .onMove('onModify called', function (text) {
          const filt = ref.$store.state.data.symbolsfilter[ref.$store.state.trade.editTrade.Symbol]
          let priceDec = 8
          let qtyDec = 8
          let amountDec = 8
          if (filt) {
            priceDec = filt.PriceDec
            qtyDec = filt.QtyDec
            amountDec = parseFloat(filt.PriceDec) + parseFloat(filt.QtyDec)
          }
          // var priceDec = ref.$store.state.data.symbolsfilter[ref.$store.state.trade.editTrade.Symbol].PriceDec
          let soPrice = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_HALF_UP).toString()
          if (ref.$store.state.sys.tradeExchange.ExchId === 'BYF') {
            soPrice = Util.truncateWithStep(this.getPrice(), filt.PriceMin).toString()
            this.setPrice(Util.truncateWithStep(this.getPrice(), filt.PriceMin).toNumber())
          }
          const soQty = '0'
          if (ref.$store.state.trade.editQtyFocused) {
            this.so.Amount = new Decimal(this.getPrice()).mul(this.so.Qty).toDP(amountDec, Decimal.ROUND_HALF_UP).toString()
          } else {
            if (!new Decimal(soPrice).equals(0)) {
              this.so.Qty = new Decimal(this.so.Amount).div(soPrice).toDP(qtyDec, Decimal.ROUND_HALF_UP).toString()
            }
          }

          this.so.Price = soPrice
          terminal.sortEditedTradeSO()
        })
        .onCancel('onCancel called', function (text) {
          this.remove()
          terminal.cancelSO(this.so)
          state.soLines = state.soLines.filter(soLine => soLine !== this)
        })
      buyLine.so = so
      state.soLines.push(buyLine)
      // console.log('so line add', so)
    },
    isDataChanged (olddata, newdata) {
      if (newdata.length !== olddata.length) {
        return true
      }
      for (let i = 0; i < newdata.length; i++) {
        if (JSON.stringify(newdata[i]) !== JSON.stringify(olddata[i])) {
          return true
        }
      }
      return false
    },
    // symbolOrdersIsChanged (newdata) {
    //   if (newdata.length !== this.storetrade.symbolOrders.length) {
    //     return true
    //   }
    //   for (let i = 0; i < newdata.length; i++) {
    //     if (JSON.stringify(newdata[i]) !== JSON.stringify(this.storetrade.symbolOrders[i])) {
    //       return true
    //     }
    //   }
    //   return false
    // },
    // symbolTPsIsChanged (newdata) {
    //   if (newdata.length !== this.storetrade.symbolTPs.length) {
    //     return true
    //   }
    //   for (let i = 0; i < newdata.length; i++) {
    //     if (JSON.stringify(newdata[i]) !== JSON.stringify(this.storetrade.symbolTPs[i])) {
    //       return true
    //     }
    //   }
    //   return false
    // },
    addOrderArrowShape (order) {
      if (!order.Executed || !state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }

      if (order.Type === 'VIRTBUY') {
        return
      }
      // console.log('add order arrow', order.Executed)
      const shape = order.Side === 'B' ? 'arrow_up' : 'arrow_down'
      const time1 = new Date(order.Executed)
      // console.log('time1', time1, time1.getTime() / 1000)
      const arrow = state.tvWidget.chart().createShape(
        {
          time: time1.getTime() / 1000,
          price: parseFloat(order.Price)
        }, {
          shape,
          lock: true,
          zOrder: 'top',
          disableSelection: true,
          disableSave: true,
          disableUndo: true,
          showInObjectsTree: false
        })

      state.filledArrows.push(arrow)
      // console.log('arrowShape added', arrow)
    },
    addViewModeOrderLineInternal (order) {
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart() || (order.Info && parseFloat(order.Info.TrailPct) > 0)) {
        return
      }
      const color = order.Side === 'B' ? '#20b2aa' : '#f08080'
      const text = order.Side === 'B' ? ' BUY ' : ' SELL '
      // console.log('viewModeTPLines before add', JSON.stringify(slim))
      const viewModeBuyLine = state.tvWidget.chart().createOrderLine()
        .setText(text + order.TradeId)
        .setPrice(parseFloat(order.Price))
        .setQuantity(order.Qty + ' ' + order.Symbol.split('_')[0])
        .setLineWidth(2)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
        .onModify('onModify called', function (text) {
          Data.vm.$bus.$emit('open-smart-trade')
          terminal.tradeGetAndSet(order.TradeId)
        })
        .onCancel('onCancel called', function (text) {
          if (order.Type === 'SO') {
            terminal.cancelSOInDB(order, this)
          } else {
            terminal.cancelTradeOnTV(order.TradeId, this)
          }
        })
      global.viewModeLines.push(viewModeBuyLine)

      // .onMove(function () {
      //   // this.setText('onMove')
      // })
      // console.log('viewModeSymbolTPLines added', order.Id)
    },
    addViewModeOrderLine (order, retryCount = 0) {
      try {
        this.addViewModeOrderLineInternal(order)
      } catch (error) {
        // console.log('Error creating view mode order line, retrying in 1 second')
        if (retryCount < TVRETRY_COUNT) {
          setTimeout(() => {
            this.addViewModeOrderLine(order, retryCount + 1)
          }, TVRETRY_DELAY)
        }
      }
    },
    addViewModeConditionalLine (order) {
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      const color = '#E8BD3C'
      const text = order.Side === 'B' ? ' BUY ' : ' SELL '
      const viewModeBuyLine = state.tvWidget.chart().createOrderLine()
        .setText(text + order.TradeId)
        .setPrice(parseFloat(order.Price))
        .setQuantity(order.Qty + ' ' + order.Symbol.split('_')[0])
        .setLineWidth(2)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
        .onModify('onModify called', function (text) {
          Data.vm.$bus.$emit('open-smart-trade')
          terminal.tradeGetAndSet(order.TradeId)
        })
        .onCancel('onCancel called', function (text) {
          terminal.cancelTradeOnTV(order.TradeId, this)
        })
      global.viewModeLines.push(viewModeBuyLine)
    },
    addViewModeSLLineInternal (order) {
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      const color = 'rgb(240,26,179)'
      const sideText = order.Side === 'B' ? 'BUY ' : 'SELL '
      const text = ' SL ' + sideText
      const viewModeSLLine = state.tvWidget.chart().createOrderLine()
        .setText(text + order.TradeId)
        .setPrice(parseFloat(order.Trigger))
        .setQuantity(order.Qty + ' ' + order.Symbol.split('_')[0])
        .setLineWidth(2)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
        .onModify('onModify called', function (text) {
          Data.vm.$bus.$emit('open-smart-trade')
          terminal.tradeGetAndSet(order.TradeId)
        })
      global.viewModeLines.push(viewModeSLLine)
    },
    addViewModeSLLine (order, retryCount = 0) {
      try {
        this.addViewModeSLLineInternal(order)
      } catch (error) {
        // console.log('Error creating view mode SL line, retrying in 1 second')
        if (retryCount < TVRETRY_COUNT) {
          setTimeout(() => {
            this.addViewModeSLLine(order, retryCount + 1)
          }, TVRETRY_DELAY)
        }
      }
    },
    addViewModeTPLineInternal (slim) {
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      const color = 'rgb(4,155,111)'
      const sideText = slim.Side === 'B' ? 'BUY ' : 'SELL '
      const text = ' TP ' + sideText

      // slim.Info.Pct + '%'
      // console.log('viewModeTPLines before add', JSON.stringify(slim))
      const viewModeBuyLine = state.tvWidget.chart().createOrderLine()
        .setText(text + slim.TradeId)
        .setPrice(parseFloat(slim.Price))
        .setQuantity(slim.Qty + ' ' + slim.Symbol.split('_')[0])
        .setLineWidth(2)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
        .onModify('onModify called', function (text) {
          Data.vm.$bus.$emit('open-smart-trade')
          terminal.tradeGetAndSet(slim.TradeId)
        })
        // .onCancel('onCancel called', function (text) {
        //   console.log('onCancel')
        // })
        // .onMove(function () {
        //   // this.setText('onMove')
        // })
      global.viewModeLines.push(viewModeBuyLine)
      // console.log('viewModeSymbolTPLines added', slim.Id)
    },
    addViewModeTPLine (slim, retryCount = 0) {
      try {
        this.addViewModeTPLineInternal(slim)
      } catch (error) {
        // console.log('Error creating view mode TP line, retrying in 1 second')
        if (retryCount < TVRETRY_COUNT) {
          setTimeout(() => {
            this.addViewModeTPLine(slim, retryCount + 1)
          }, TVRETRY_DELAY)
        }
      }
    },
    drawSymbolTPsAndOrders2 () {
      if (!this.$store.state.sys.tradeExchange.Id || !this.storetrade.symbol || !this.$store.state.trade.showOrders) {
        return
      }
      const ref = this
      SlimApis[Util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)].get('trade/actorders', {
        params: {
          token: this.$store.state.sys.token,
          etid: this.$store.state.sys.tradeExchange.Id,
          symbol: this.storetrade.symbol
        }
      }).then(function (response) {
        // console.log('orders', JSON.stringify(response.data))
        if (response.data !== null) {
          if (!response.data.err) {
            // ok
            let slims = []
            let orders = []
            let so = []
            let cond = []
            let sl = []
            if (response.data.Slims) {
              slims = response.data.Slims
            }
            if (response.data.Orders) {
              orders = response.data.Orders
            }
            if (response.data.So) {
              so = response.data.So
            }
            if (response.data.Cond) {
              cond = response.data.Cond
            }
            if (response.data.Sl) {
              sl = response.data.Sl
            }
            if (ref.isDataChanged(ref.storetrade.symbolTPs, slims) || ref.isDataChanged(ref.storetrade.symbolOrders, orders) || ref.isDataChanged(ref.storetrade.symbolSOs, so) || ref.isDataChanged(ref.storetrade.symbolConds, cond) ||
              ref.isDataChanged(ref.storetrade.symbolSLs, sl)) {
              global.viewModeLines.forEach(line => line.remove())
              global.viewModeLines = []
              // console.log('clean viewModeTPLines', global.viewModeLines)

              if (!ref.storetrade.editTrade) {
                slims.forEach(step => {
                  ref.addViewModeTPLine(step)
                })
                orders.forEach(order => {
                  ref.addViewModeOrderLine(order)
                })
                so.forEach(order => {
                  ref.addViewModeOrderLine(order)
                })
                cond.forEach(order => {
                  ref.addViewModeConditionalLine(order)
                })
                sl.forEach(order => {
                  ref.addViewModeSLLine(order)
                })
              }

              ref.storetrade.symbolTPs = slims
              ref.storetrade.symbolOrders = orders
              ref.storetrade.symbolSOs = so
              ref.storetrade.symbolConds = cond
              ref.storetrade.symbolSLs = sl

              ref.drawSymbolExeOrdersArrows()
            }
          } else {
            // error
            ref.$Notice.error({
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        }
      }).catch(function (error) {
        // error
        console.log(error)
        if (this.ignoreError(error)) {
          return
        }
        ref.$Notice.error({
          title: ref.$text.tr('Ошибка'),
          desc: Util.returnTextForErr(error),
          duration: 10
        })
      })
    },
    drawSymbolTPsAndOrders () {
      if (!this.$store.state.sys.tradeExchange.Id || !this.storetrade.symbol || !this.$store.state.trade.showOrders) {
        return
      }
      const ref = this
      SlimApis[Util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)].get('trade/actorders', {
        params: {
          token: this.$store.state.sys.token,
          etid: this.$store.state.sys.tradeExchange.Id,
          symbol: this.storetrade.symbol
        }
      }).then(function (response) {
        // console.log('orders', JSON.stringify(response.data))
        if (response.data !== null) {
          if (!response.data.err) {
            // ok
            let slims = []
            let orders = []
            let so = []
            let cond = []
            let sl = []
            if (response.data.Slims) {
              slims = response.data.Slims
            }
            if (response.data.Orders) {
              orders = response.data.Orders
            }
            if (response.data.So) {
              so = response.data.So
            }
            if (response.data.Cond) {
              cond = response.data.Cond
            }
            if (response.data.Sl) {
              sl = response.data.Sl
            }
            ref.storetrade.symbolTPs = slims
            ref.storetrade.symbolOrders = orders
            ref.storetrade.symbolSOs = so
            ref.storetrade.symbolConds = cond
            ref.storetrade.symbolSLs = sl

            if (!ref.storetrade.editTrade) {
              ref.storetrade.symbolTPs.forEach(step => {
                ref.addViewModeTPLine(step)
              })
              ref.storetrade.symbolOrders.forEach(order => {
                ref.addViewModeOrderLine(order)
              })
              ref.storetrade.symbolSOs.forEach(order => {
                ref.addViewModeOrderLine(order)
              })
              ref.storetrade.symbolConds.forEach(order => {
                ref.addViewModeConditionalLine(order)
              })
              ref.storetrade.symbolSLs.forEach(order => {
                ref.addViewModeSLLine(order)
              })
              // console.log('sos', JSON.stringify(ref.storetrade.symbolSOs))
            }
          } else {
            // error
            ref.$Notice.error({
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        }
      }).catch(function (error) {
        // error
        console.log(error)
        if (ref.ignoreError(error)) {
          return
        }
        ref.$Notice.error({
          title: ref.$text.tr('Ошибка'),
          desc: Util.returnTextForErr(error),
          duration: 10
        })
      })
    },
    drawSymbolExeOrdersArrows () {
      if (!this.$store.state.sys.tradeExchange.ExchId) {
        return
      }
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      if (this.storetrade.showArrors === false) {
        return
      }
      const ref = this
      SlimApis[Util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)].get('trade/exeorders', {
        params: {
          token: this.$store.state.sys.token,
          etid: this.$store.state.sys.tradeExchange.Id,
          symbol: this.storetrade.symbol
        }
      }).then(function (response) {
        // console.log('get Executed Trade Orders', response.data)
        if (response.data !== null) {
          if (!response.data.err) {
            state.filledOrders = response.data.Orders || []
            state.filledSlims = response.data.Slims || []
            ref.redrawFilledArrows()
          } else {
            // error
            ref.$Notice.error({
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        }
      }).catch(function (error) {
        // error
        console.log(error)
        if (this.ignoreError(error)) {
          return
        }
        ref.$Notice.error({
          title: ref.$text.tr('Ошибка'),
          desc: Util.returnTextForErr(error),
          duration: 10
        })
      })
    },
    ignoreError (error) {
      if (error.message === 'Cannot read property \'distance\' of null' ||
        error.message === 'Cannot read property \'_model\' of undefined' ||
        error.message === 'Cannot read property \'chart\' of undefined' ||
        error.message === 'Request failed with status code 401' ||
        error.message.includes('Value is null')) {
        return true
      }
      return false
    },
    saveTVData () {
      // console.log('BOT onAutoSaveNeeded')
      state.tvWidget.save(this.saveTermTV)
    },
    saveTermTV (state) {
      const statestr = JSON.stringify(state)
      if (statestr === this.prevState) {
        // console.log('term tvdata save skipped')
        return
      }
      const md = new MobileDetect(window.navigator.userAgent)
      if (md.mobile()) {
        return
      }
      Api.post('user/tvdata?mode=term&cmd=save&token=' + this.$store.state.sys.token, state)
        .then(res => {
          // console.log(res)
          this.prevState = statestr
          // console.log('term tvdata saved', state)
        })
        .catch(error => {
          console.log(error)
        })
      // console.log('tvdata saved', state)
    },
    sortTradeSteps () {
      if (this.$store.state.trade.editTrade.tpsteps && this.$store.state.trade.editTrade.tpsteps.length > 1) {
        let k = 1
        if (this.$store.state.trade.editTrade.Side === 'S') {
          k = -1
        }
        this.$store.state.trade.editTrade.tpsteps.sort((a, b) => {
          if (a.Status < b.Status) {
            return 1
          } else if (a.Status > b.Status) {
            return -1
          } else {
            return parseFloat(a.Price) >= parseFloat(b.Price) ? 1 * k : -1 * k
          }
        })
      }
    },
    addAverageBuyLineInternal (trade, buys) {
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      if (state.averageBuyLine) {
        state.averageBuyLine.remove()
      }
      // var direction = trade.Side === 'B' ? 'ПОКУПКА' : 'ПРОДАЖА'
      const direction = this.$text.tr('СР ЦЕНА')
      state.averageBuyLine = state.tvWidget.chart().createPositionLine()
        // .onModify(function () {
        //   this.setText('onModify called')
        // })
        // .onReverse('onReverse called', function (text) {
        //   this.setText(text)
        // })
        // .onClose('onClose called', function (text) {
        //   this.setText(text)
        // })
        .setText(direction)
        .setQuantity('')
        // .setQuantity(trade.Qty + ' ' + trade.Symbol.split('_')[0])
        .setPrice(parseFloat(trade.Price))
        // .setExtendLeft(false)
        .setLineStyle(0)
        .setLineLength(1)
        .setLineWidth(2)
    },
    addAverageBuyLine (trade, buys, retryCount = 0) {
      try {
        this.addAverageBuyLineInternal(trade, buys)
      } catch (error) {
        // console.log('Error creating position line, retrying in 1 second')
        if (retryCount < TVRETRY_COUNT) {
          setTimeout(() => {
            this.addAverageBuyLine(trade, buys, retryCount + 1)
          }, TVRETRY_DELAY)
        }
      }
    },
    addFilledOrderArrowShape (order) {
      if (!order.Ts || order.Status !== 'EXC') {
        return
      }
      if (order.Type === 'VIRTBUY') {
        return
      }
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      // console.log('add arrow', order.Executed)
      const shape = order.Side === 'B' ? 'arrow_up' : 'arrow_down'
      // var sign = trade.Side === 'B' ? '+' : '-'
      // var clr = order.Side === 'B' ? '#0F0' : '#ff0137'
      const time1 = new Date(order.Ts)
      // console.log('time1', time1, time1.getTime() / 1000)
      // console.log('price', order.Price, parseFloat(order.Price))
      const arrow = state.tvWidget.chart().createShape(
        {
          time: time1.getTime() / 1000,
          price: parseFloat(order.Price)
        }, {
          shape,
          lock: true,
          zOrder: 'top',
          disableSelection: true,
          disableSave: true,
          disableUndo: true,
          showInObjectsTree: false
        })

      // this.eb.orderArrows.push(arrow)
      state.filledArrows.push(arrow)
      // console.log('arrowShape added', arrow, order.Side, order.Price)

      // .setFont('10pt Verdana')
      // .setPrice(parseFloat(trade.Price))
    },
    addBuyArrow (trade, buy) {
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      // console.log('add buy arrow', buy)
      const direction = trade.Side === 'B' ? 'buy' : 'sell'
      const sign = trade.Side === 'B' ? '+' : '-'
      const clr = trade.Side === 'B' ? '#0F0' : '#F00'
      const time1 = new Date(buy.Ts)
      // console.log('time1', time1)
      const arrow = state.tvWidget.chart().createExecutionShape()
        .setText(sign + buy.Qty + ' ' + trade.Symbol.split('_')[0])
        // .setTooltip('')
        // .setTextColor('rgba(0,255,0,0.5)')
        .setTextColor(clr)
        .setArrowColor(clr)
        .setDirection(direction)
        .setTime(time1.getTime() / 1000)
        .setArrowHeight(16)
        .setArrowSpacing(4)
        .setFont('10pt Verdana')
      // .setPrice(parseFloat(trade.Price))
      state.arrows.push(arrow)
    },
    redrawFilledArrows () {
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) return
      this.cleanFilledArrows()
      if (this.storetrade.showArrors === false) return
      state.filledSlims.forEach(order => {
        this.addOrderArrowShape(order)
      })
      state.filledOrders.forEach(order => {
        this.addOrderArrowShape(order)
      })
    },
    showSltp () {
      this.resizing = true
      this.$store.state.sltpIndex = -1
      this.$store.state.sltpTrade = true
      this.$store.state.sltpModal = true
    },
    stopResize (e) {
      window.removeEventListener('mousemove', this.resize, true)
      window.removeEventListener('mouseup', this.stopResize, false)
      this.resizing = false
    },
    resize (e) {
      // this.element.style.width = (e.clientX - this.element.offsetLeft) + 'px'
      // console.log('client x Y:', e.clientX, e.clientY)
      // console.log('element:', this.element.offsetTop)
      this.element.style.height = (e.clientY - this.element.offsetTop - 70) + 'px'
    },
    initResize () {
      this.resizing = true
      this.element = document.getElementById(this.containerId)
      window.addEventListener('mousemove', this.resize, true)
      window.addEventListener('mouseup', this.stopResize, false)
    },
    cleanLines () {
      if (state.tvWidget) {
        if (state.buyLine) {
          state.buyLine.remove()
          state.buyLine = null
        }
        state.tpLines.forEach(tpline => tpline.remove())
        state.tpLines = []
        if (state.slLine) {
          state.slLine.remove()
          state.slLine = null
        }
        if (state.averageBuyLine) {
          state.averageBuyLine.remove()
          state.averageBuyLine = null
        }
        if (state.liquidationLine) {
          state.liquidationLine.remove()
          state.liquidationLine = null
        }
        // console.log('clean arrows', state.arrows.length)
        state.arrows.forEach(arrow => arrow.remove())
        state.arrows = []

        global.viewModeLines.forEach(line => line.remove())
        global.viewModeLines = []
        // console.log('clean viewModeTPLines', global.viewModeLines)

        state.soLines.forEach(soline => soline.remove())
        state.soLines = []

        state.triggerLines.forEach(soline => soline.remove())
        state.triggerLines = []

        state.soTrailingLines.forEach(soline => soline.remove())
        state.soTrailingLines = []

        this.createChart()
      }
    },
    cleanBuyLine () {
      if (state.tvWidget) {
        if (state.buyLine) {
          state.buyLine.remove()
          state.buyLine = null
          // console.log('buy line cleaned')
        }
      }
    },
    cleanFilledArrows () {
      // console.log('tvWidget', state.tvWidget)
      if (!state.tvWidget) {
        return
      }
      if (state.tvWidget && state.tvWidget._ready && state.tvWidget.chart()) {
        state.filledArrows.forEach(a => {
          state.tvWidget.chart().removeEntity(a, { disableUndo: true })
          // console.log('arrowShape removed', a)
        })
        state.filledArrows = []
      }
    },
    formSlLine (price, slprice) {
      if (!state.slLine && slprice) {
        this.addSlLine()
      }
      if (state.slLine) {
        if (slprice) {
          state.slLine.setPrice(parseFloat(slprice))
          let slPct = new Decimal(price).sub(slprice).div(price).mul(100).toNumber()
          if (slPct < 0) {
            slPct = -1 * slPct
          }
          state.slLine.setText('SL: -' + slPct.toFixed(1) + '%')
        } else {
          state.slLine.remove()
          state.slLine = null
        }
      }
    },
    formTpLines () {
      // console.log('formTpLines')
      state.tpLines.forEach(tpLine => {
        tpLine.remove()
      })
      state.tpLines = []
      this.$store.state.trade.tpsteps.forEach(step => {
        this.addTpLine(step)
      })
      if (this.$store.state.trade.tpsteps.length === 0 && this.$store.state.trade.tpprice) {
        const step = {
          Price: this.$store.state.trade.tpprice,
          Pct: new Decimal(100),
          Qty: this.$store.state.trade.qty
        }
        this.addTpLine(step)
      }
    },
    formTradeTpLinesInternal () {
      // console.log('formTradeTpLines')
      state.tpLines.forEach(tpLine => {
        tpLine.remove()
      })
      state.tpLines = []
      const trade = this.$store.state.trade.editTrade
      // console.log('formTradeTpLines', trade.tpsteps)
      if (trade && trade.tpsteps) {
        trade.tpsteps.forEach(step => {
          if (step.Status === 'ACT' || step.Status === 'NEW') {
            this.addTpLine(step)
          }
        })
      }
      // if ((!trade.tpsteps || trade.tpsteps.length === 0) && trade.Sltp &&
      //   parseFloat(trade.Sltp.TpPrice) > 0) {
      //   var step = {
      //     Price: trade.Sltp.TpPrice,
      //     Pct: new Decimal(100),
      //     Qty: trade.Qty
      //   }
      //   this.addTpLine(step)
      // }
    },
    formTradeTpLines (retryCount = 0) {
      try {
        this.formTradeTpLinesInternal()
      } catch (error) {
        // console.log('Error forming trade TP lines, retrying in 1 second')
        if (retryCount < TVRETRY_COUNT) {
          setTimeout(() => {
            this.formTradeTpLines(retryCount + 1)
          }, TVRETRY_DELAY)
        }
      }
    },
    resetTpLines () {
      const qtyDec = this.$store.state.data.symbolsfilter[this.$store.state.trade.symbol].QtyDec
      let qtyPctSteps = new Decimal(0)
      let qtySteps = new Decimal(0)
      let freePcts = 100
      let editTrade = this.$store.state.trade.editTrade
      let editTradeQtyLeft = 0

      if (editTrade) {
        editTradeQtyLeft = editTrade.Info.QtyLeft !== '0' ? editTrade.Info.QtyLeft : editTrade.Qty
      } else {
        editTrade = {}
        editTrade.Qty = this.$store.state.trade.qty
        editTradeQtyLeft = this.$store.state.trade.qty
      }

      if (editTrade && editTrade.tpsteps) {
        editTrade.tpsteps.forEach(step => {
          if (step.Status === 'EXC') {
            freePcts -= step.Pct
          }
        })
      }

      state.tpLines.forEach((line, index) => {
        if (index === state.tpLines.length - 1) {
          line.Step.Pct = new Decimal(freePcts).sub(qtyPctSteps).toString()
          line.Step.Qty = new Decimal(editTradeQtyLeft).sub(qtySteps).toDP(qtyDec, Decimal.ROUND_DOWN).toString()
          line.Step.Amount = new Decimal(line.Step.Qty).mul(line.Step.Price).toDP(qtyDec, Decimal.ROUND_DOWN).toString()
        } else {
          line.Step.Pct = new Decimal(freePcts).div(state.tpLines.length).toDP(0, Decimal.ROUND_DOWN).toString()
          line.Step.Qty = new Decimal(editTrade.Qty).mul(line.Step.Pct).mul('0.01').toDP(qtyDec, Decimal.ROUND_HALF_UP).toString()
          line.Step.Amount = new Decimal(line.Step.Qty).mul(line.Step.Price).toDP(qtyDec, Decimal.ROUND_DOWN).toString()
          qtyPctSteps = qtyPctSteps.add(line.Step.Pct)
          qtySteps = qtySteps.add(line.Step.Qty)
        }

        line.setQuantity(line.Step.Pct + '% ' + this.$store.state.trade.pair[0])
      })
    },
    formTpSteps () {
      let k = 1
      if (this.$store.state.trade.side === 'S') {
        k = -1
      }
      const steps = []
      if (state.tpLines.length > 0) {
        state.tpLines.sort((a, b) => {
          return new Decimal(a.getPrice()).comparedTo(b.getPrice()) * k
        })
        state.tpLines.forEach(tpLine => {
          tpLine.Step.Status = 'ACT'
          steps.push(tpLine.Step)
        })
      }
      // console.log('steps:', steps)
      const trade = this.$store.state.trade.editTrade
      if (trade) {
        // trade.tpsteps = steps
        Vue.set(trade, 'tpsteps', steps)
        // console.log('tpsteps:', trade.tpsteps)
      } else {
        this.$store.state.trade.tpsteps = steps
        if (state.tpLines.length > 0) {
          this.$store.state.trade.tpprice = state.tpLines[0].Step.Price
        }
      }
    },
    addButtons () {
      if (state.tvWidget) {
        state.tvWidget.headerReady().then(() => {
          const slBtn = state.tvWidget.createButton()
          slBtn.textContent = '+SL'
          slBtn.addEventListener('click', () => {
            const trade = this.$store.state.trade.editTrade
            if (trade) {
              // edit mode
              // console.log('state.slLine', state.slLine)
              if (!state.slLine) {
                const priceDec = this.$store.state.data.symbolsfilter[trade.Symbol].PriceDec
                const mult = trade.Side === 'B' ? 0.99 : 1.01
                let comparePrice = this.$store.state.sys.lastPrice
                if (trade.Status === 'ORDSUBMIT') {
                  comparePrice = trade.Price
                }
                if (!trade.Sltp) {
                  // trade.Sltp = {}
                  Vue.set(this.$store.state.trade.editTrade, 'Sltp', { SlPrice: new Decimal(comparePrice).mul(mult).toDP(priceDec, Decimal.ROUND_DOWN).toString() })
                  // console.log('editTrade.Sltp', this.$store.state.trade.editTrade.Sltp)
                } else {
                  trade.Sltp.SlPrice = new Decimal(comparePrice).mul(mult).toDP(priceDec, Decimal.ROUND_DOWN).toString()
                }
                this.addTradeSlLine(trade)
              }
            } else {
              // new trade mode
              if (!state.slLine) {
                this.addSlLine()
              }
            }
          })
          slBtn.style.color = '#C26868'

          const tpBtn = state.tvWidget.createButton()
          tpBtn.textContent = '+TP'
          tpBtn.addEventListener('click', () => {
            if (state.tpLines.length > 3) {
              return
            }
            const trade = this.$store.state.trade.editTrade
            if (trade) {
              // max 4 steps
              if (trade.tpsteps && trade.tpsteps.length > 3) {
                return
              }
              // edit mode
              this.addNewTradeTpLine()
              // this.formTpSteps()
            } else {
              // new trade mode
              this.addNewTpLine()
            }
          })
          tpBtn.style.color = '#188983'

          const arrorsBtn = state.tvWidget.createButton()
          if (this.$store.state.trade.showArrors === true) {
            arrorsBtn.textContent = this.$text.tr('Bыкл') + ' ⇧'
          } else {
            arrorsBtn.textContent = this.$text.tr('Bкл') + ' ⇧'
          }
          arrorsBtn.addEventListener('click', () => {
            this.$store.state.trade.showArrors = !this.$store.state.trade.showArrors
            localStorage.setItem('capico_app_tv_showArrows', this.$store.state.trade.showArrors)
            if (this.$store.state.trade.showArrors === true) {
              arrorsBtn.textContent = this.$text.tr('Bыкл') + ' ⇧'
            } else {
              arrorsBtn.textContent = this.$text.tr('Bкл') + ' ⇧'
            }
          })
          arrorsBtn.style.color = '#8e65e6'

          const ordersBtn = state.tvWidget.createButton()
          if (this.$store.state.trade.showOrders) {
            ordersBtn.textContent = this.$text.tr('Bыкл') + ' ---'
          } else {
            ordersBtn.textContent = this.$text.tr('Bкл') + ' ---'
          }
          ordersBtn.style.color = '#6b74e7'

          ordersBtn.addEventListener('click', () => {
            if (this.$store.state.trade.editTrade) {
              return
            }

            this.$store.state.trade.showOrders = !this.$store.state.trade.showOrders
            localStorage.setItem('capico_app_tv_showOrders', this.$store.state.trade.showOrders)

            if (this.$store.state.trade.showOrders) {
              ordersBtn.textContent = this.$text.tr('Bыкл') + ' ---'
              this.drawSymbolTPsAndOrders()
            } else {
              ordersBtn.textContent = this.$text.tr('Bкл') + ' ---'
              this.cleanLines()
            }
          })
        })
      }
    },
    addTradeBuyLine (trade) {
      if (state.averageBuyLine) {
        state.averageBuyLine.remove()
        state.averageBuyLine = null
      }
      // console.log('addTradeBuyLine')
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      // let ref = this
      const color = '#6e87cc'
      const side = trade.Side === 'B' ? this.$text.tr('ПОКУПКА') : this.$text.tr('ПРОДАЖА')
      state.averageBuyLine = state.tvWidget.chart().createOrderLine()
        // .onMove(function () {
        //   // this.setText('onMove called')
        //   var priceDec = ref.$store.state.data.symbolsfilter[trade.Symbol].PriceDec
        //   trade.Price = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_DOWN).toString()
        //
        //   if (trade.Side === 'B') {
        //     state.tpLines.forEach(tpLine => {
        //       if (new Decimal(tpLine.getPrice()).lessThanOrEqualTo(trade.Price)) {
        //         var tpPrice = new Decimal(trade.Price).mul(1.005).toDP(priceDec, Decimal.ROUND_DOWN).toString()
        //         tpLine.setPrice(parseFloat(tpPrice))
        //         tpLine.Step.Price = tpPrice
        //       }
        //       var tpPct = new Decimal(tpLine.getPrice()).sub(trade.Price).div(trade.Price).mul(100).toNumber().toFixed(1)
        //       tpLine.setText('TP: +' + tpPct + '%')
        //     })
        //     if (state.slLine) {
        //       if (new Decimal(state.slLine.getPrice()).greaterThanOrEqualTo(trade.Price)) {
        //         trade.Sltp.SlPrice = new Decimal(trade.Price).mul(0.995).toDP(priceDec, Decimal.ROUND_DOWN).toString()
        //         state.slLine.setPrice(parseFloat(trade.Sltp.SlPrice))
        //       }
        //       var slPct = new Decimal(trade.Price).sub(trade.Sltp.SlPrice).div(trade.Price).mul(100).toNumber().toFixed(1)
        //       state.slLine.setText('SL: -' + slPct + '%')
        //     }
        //   } else {
        //     state.tpLines.forEach(tpLine => {
        //       if (new Decimal(tpLine.getPrice()).greaterThanOrEqualTo(trade.Price)) {
        //         var tpPrice = new Decimal(trade.Price).mul(0.995).toDP(priceDec, Decimal.ROUND_DOWN).toString()
        //         tpLine.setPrice(parseFloat(tpPrice))
        //         tpLine.Step.Price = tpPrice
        //       }
        //       var tpPct2 = new Decimal(tpLine.getPrice()).sub(trade.Price).div(trade.Price).mul(100).neg().toNumber().toFixed(1)
        //       tpLine.setText('TP: +' + tpPct2 + '%')
        //     })
        //     if (state.slLine) {
        //       if (new Decimal(state.slLine.getPrice()).lessThanOrEqualTo(trade.Price)) {
        //         trade.Sltp.SlPrice = new Decimal(trade.Price).mul(1.005).toDP(priceDec, Decimal.ROUND_DOWN).toString()
        //         state.slLine.setPrice(parseFloat(trade.Sltp.SlPrice))
        //       }
        //       var slPct2 = new Decimal(trade.Price).sub(trade.Sltp.SlPrice).div(trade.Price).mul(100).neg().toNumber().toFixed(1)
        //       state.slLine.setText('SL: -' + slPct2 + '%')
        //     }
        //   }
        // })
        .onModify('onModify called', function (text) {
          // this.setText(text)
        })
        .setText(side)
        .setPrice(parseFloat(trade.Price))
        .setQuantity(trade.Qty + ' ' + trade.Symbol.split('_')[0])
        .setLineStyle(1)
        .setLineLength(1)
        .setLineWidth(2)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
    },
    addBuyLine () {
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      const newQty = this.storetrade.qty
      const ref = this
      const color = '#6e87cc'
      const side = this.$store.state.trade.side === 'B' ? this.$text.tr('ПОКУПКА') : this.$text.tr('ПРОДАЖА')
      const resetSlTpLines = this.resetSlTpLines

      state.buyLine = state.tvWidget.chart().createOrderLine()
        .onMove(function () {
          if ($store.state.sys.tradeExchange.ExchId === 'BYF') {
            const filt = $store.state.data.symbolsfilter[$store.state.trade.symbol]
            this.setPrice(Util.truncateWithStep(this.getPrice(), filt.PriceMin).toNumber())
          }
          resetSlTpLines(this.getPrice())
        })
        .onModify('onModify called', function (text) {
          // this.setText(text)
        })
        .onCancel('onCancel called', function (text) {
          // this.setText(text)
          this.remove()
          state.buyLine = null
          ref.$store.state.trade.qty = '0'
        })
        .setText(side)
        .setPrice(parseFloat(this.storetrade.price))
        .setQuantity(newQty + ' ' + this.$store.state.trade.pair[0])
        .setLineStyle(1)
        .setLineLength(1)
        .setLineWidth(2)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
    },
    resetSlTpLines (price = this.$store.state.trade.price) {
      const ref = this
      const priceDec = ref.$store.state.data.symbolsfilter[ref.$store.state.trade.symbol].PriceDec
      ref.$store.state.trade.price = new Decimal(price).toDP(priceDec, Decimal.ROUND_HALF_UP).toString()

      if (ref.$store.state.trade.side === 'B') {
        state.tpLines.forEach(tpLine => {
          if (new Decimal(tpLine.getPrice()).lessThanOrEqualTo(ref.$store.state.trade.price)) {
            const tpPrice = new Decimal(ref.$store.state.trade.price).mul(1.005).toDP(priceDec, Decimal.ROUND_DOWN).toString()
            tpLine.setPrice(parseFloat(tpPrice))
            tpLine.Step.Price = tpPrice
          }
          const tpPct = new Decimal(tpLine.getPrice()).sub(ref.$store.state.trade.price).div(ref.$store.state.trade.price).mul(100).toNumber().toFixed(1)
          tpLine.setText('TP: +' + tpPct + '%')
        })
        if (state.slLine) {
          if (new Decimal(state.slLine.getPrice()).greaterThanOrEqualTo(ref.$store.state.trade.price)) {
            ref.$store.state.trade.slprice = new Decimal(ref.$store.state.trade.price).mul(0.995).toDP(priceDec, Decimal.ROUND_DOWN).toString()
            state.slLine.setPrice(parseFloat(ref.$store.state.trade.slprice))
          }
          const slPct = new Decimal(ref.$store.state.trade.price).sub(ref.$store.state.trade.slprice).div(ref.$store.state.trade.price).mul(100).toNumber().toFixed(1)
          state.slLine.setText('SL: -' + slPct + '%')
        }
      } else {
        state.tpLines.forEach(tpLine => {
          if (new Decimal(tpLine.getPrice()).greaterThanOrEqualTo(ref.$store.state.trade.price)) {
            const tpPrice = new Decimal(ref.$store.state.trade.price).mul(0.995).toDP(priceDec, Decimal.ROUND_DOWN).toString()
            tpLine.setPrice(parseFloat(tpPrice))
            tpLine.Step.Price = tpPrice
          }
          const tpPct2 = new Decimal(tpLine.getPrice()).sub(ref.$store.state.trade.price).div(ref.$store.state.trade.price).mul(100).neg().toNumber().toFixed(1)
          tpLine.setText('TP: +' + tpPct2 + '%')
        })
        if (state.slLine) {
          if (new Decimal(state.slLine.getPrice()).lessThanOrEqualTo(ref.$store.state.trade.price)) {
            ref.$store.state.trade.slprice = new Decimal(ref.$store.state.trade.price).mul(1.005).toDP(priceDec, Decimal.ROUND_DOWN).toString()
            state.slLine.setPrice(parseFloat(ref.$store.state.trade.slprice))
          }
          const slPct2 = new Decimal(ref.$store.state.trade.price).sub(ref.$store.state.trade.slprice).div(ref.$store.state.trade.price).mul(100).neg().toNumber().toFixed(1)
          state.slLine.setText('SL: -' + slPct2 + '%')
        }
      }
    },
    addNewTpLine () {
      if (!state.buyLine && this.storetrade.type !== 'market') {
        this.addBuyLine()
      }
      // ref.$store.state.trade.tpprice = new Decimal(ref.$store.state.trade.price).mul(1.005).toDP(priceDec, Decimal.ROUND_DOWN).toString()
      const priceDec = this.$store.state.data.symbolsfilter[this.$store.state.trade.symbol].PriceDec
      const mult = this.$store.state.trade.side === 'B' ? 1.01 : 0.99
      const step = {
        Price: new Decimal(this.$store.state.trade.price).mul(mult).toDP(priceDec, Decimal.ROUND_DOWN).toString(),
        Pct: new Decimal(100),
        Qty: this.$store.state.trade.qty
      }
      this.addTpLine(step)
      this.resetTpLines()
      const trade = this.$store.state.trade.editTrade
      if (!trade) {
        this.formTpSteps()
      }
    },
    addNewTradeTpLine () {
      const step = terminal.createTpStep()
      this.addTpLine(step)
      this.sortTradeSteps()
      this.resetTpLines()
    },
    addTpLine (step) {
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      const ref = this
      const color = 'rgb(4,155,111)'
      // var color = '#20b2aa'
      const priceDec = ref.$store.state.data.symbolsfilter[ref.$store.state.trade.symbol].PriceDec
      // ref.$store.state.trade.tpprice = new Decimal(ref.$store.state.trade.price).mul(1.005).toDP(priceDec, Decimal.ROUND_DOWN).toString()

      let buyPrice = new Decimal(0)
      if (ref.$store.state.trade && ref.$store.state.trade.price !== '') {
        buyPrice = new Decimal(ref.$store.state.trade.price)
      }
      let side = ref.$store.state.trade.side

      const trade = this.$store.state.trade.editTrade
      if (trade) {
        if (trade.Status === 'ORDSUBMIT' || trade.Status === 'COND') {
          buyPrice = terminal.returnAverageTradePrice(trade)
        } else {
          buyPrice = new Decimal(trade.Price)
        }
        side = trade.Side
      }

      let plus = ''
      const stepPrice = terminal.returnDecimalValue(step.Price)
      let tpPct = new Decimal(0).toNumber()
      if (!buyPrice.equals(0)) {
        tpPct = stepPrice.sub(buyPrice).div(buyPrice).mul(100).toNumber()
        if (side === 'S') {
          tpPct = -1 * tpPct
        }
        if (tpPct > 0) {
          plus = '+'
        }
      }
      const tpLine = state.tvWidget.chart().createOrderLine()
        .onMove(function () {
          // move back incorrect take profit
          // var comparePrice = ref.$store.state.trade.price
          // if (trade) {
          //   if (trade.Status === 'ORDSUBMIT' || trade.Status === 'COND') {
          //     comparePrice = terminal.returnAverageTradePrice(trade)
          //   } else {
          //     comparePrice = ref.$store.state.sys.lastPrice
          //   }
          // }
          // console.log('lastPrice', ref.$store.state.sys.lastPrice)
          // console.log('comparePrice', comparePrice)

          let side = ref.$store.state.trade.side
          if (trade) {
            side = trade.Side
          }
          // if (side === 'B') {
          //   if (new Decimal(this.getPrice()).lessThanOrEqualTo(comparePrice)) {
          //     this.setPrice(new Decimal(comparePrice).mul(1.005).toDP(priceDec, Decimal.ROUND_DOWN).toNumber())
          //   }
          // } else {
          //   if (new Decimal(this.getPrice()).greaterThanOrEqualTo(comparePrice)) {
          //     this.setPrice(new Decimal(comparePrice).mul(0.995).toDP(priceDec, Decimal.ROUND_DOWN).toNumber())
          //   }
          // }
          // this.setText('onMove called')
          let tpPrice = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_HALF_UP).toString()
          if (ref.$store.state.sys.tradeExchange.ExchId === 'BYF') {
            const filt = ref.$store.state.data.symbolsfilter[ref.$store.state.trade.symbol]
            tpPrice = Util.truncateWithStep(this.getPrice(), filt.PriceMin).toString()
            this.setPrice(Util.truncateWithStep(this.getPrice(), filt.PriceMin).toNumber())
          }

          const tpAmount = new Decimal(tpPrice).mul(this.Step.Qty).toDP(4, Decimal.ROUND_HALF_UP).toString()
          // ref.$store.state.trade.tpprice = tpPrice
          this.Step.Price = tpPrice
          this.Step.Amount = tpAmount

          let tpPct1 = new Decimal(0).toNumber()
          if (!buyPrice.equals(0)) {
            tpPct1 = new Decimal(tpPrice).sub(buyPrice).div(buyPrice).mul(100).toNumber()
            if (side === 'S') {
              tpPct1 = -1 * tpPct1
            }
          }

          // this.setText('TP: +' + tpPct1.toFixed(1) + '%')

          if (trade) {
            ref.sortTradeSteps()
          } else {
            ref.formTpSteps()
          }
        })
        .onModify('onModify called', function (text) {
          // this.setText(text)
          // ref.$store.state.confirmModal.show = true
          // ref.showSltp()
        })
        .onCancel('onCancel called', function (text) {
          this.remove()
          const trade = ref.$store.state.trade.editTrade
          if (trade) {
            trade.tpsteps = trade.tpsteps.filter(step1 => step1 !== step)
          } else {
            ref.$store.state.trade.tpsteps = ref.$store.state.trade.tpsteps.filter(step1 => step1 !== step)
          }
          state.tpLines = state.tpLines.filter(tpLine => tpLine !== this)
          ref.resetTpLines()
          if (state.tpLines.length === 0) {
            ref.$store.state.trade.tpprice = ''
          }
        })
        .setText('TP: ' + plus + tpPct.toFixed(1) + '%')
        .setPrice(parseFloat(step.Price))
        // .setQuantity(this.$store.state.trade.qty + ' ' + this.$store.state.trade.pair[0])
        .setQuantity(step.Pct + '% ' + this.$store.state.trade.pair[0])
        .setLineStyle(1)
        .setLineLength(1)
        .setLineWidth(2)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
      // this.tpLine.cPrice = ref.$store.state.trade.tpprice
      // this.tpLine.cQtyPct = 0
      // this.tpLine.cQty = this.$store.state.trade.qty
      tpLine.Step = step
      // console.log('tp line created', step)
      state.tpLines.push(tpLine)
    },
    addTradeSlLineInternal (trade) {
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      if (state.slLine) {
        state.slLine.remove()
      }

      const color = 'rgb(240,26,179)'
      const ref = this
      const priceDec = ref.$store.state.data.symbolsfilter[trade.Symbol].PriceDec

      // var slPct = new Decimal(trade.Price).sub(trade.Sltp.SlPrice).div(trade.Price).mul(100).toNumber().toFixed(1)
      const slPct = this.returnSlPct(trade)

      // if (trade.Side === 'B') {
      //   slPct = -1 * slPct
      // }

      let plus = ''
      if (slPct > 0) {
        plus = '+'
      }

      ref.$store.state.trade.slAdded = true
      const slLine = state.tvWidget.chart().createOrderLine()
        .onMove(function () {
          let comparePrice = ref.$store.state.sys.lastPrice
          if (trade.Status === 'ORDSUBMIT' || trade.Status === 'COND') {
            if (trade.so && trade.so.length > 0) {
              comparePrice = trade.so[0].Price
            } else {
              comparePrice = trade.Price
            }
          }
          // move back incorrect stop loss
          if (!ref.$store.state.trade.slcEnabled) {
            if (trade.Side === 'B') {
              if (new Decimal(this.getPrice()).greaterThanOrEqualTo(comparePrice)) {
                this.setPrice(new Decimal(comparePrice).mul(0.995).toDP(priceDec, Decimal.ROUND_DOWN).toNumber())
              }
            } else {
              if (new Decimal(this.getPrice()).lessThanOrEqualTo(comparePrice)) {
                this.setPrice(new Decimal(comparePrice).mul(1.005).toDP(priceDec, Decimal.ROUND_DOWN).toNumber())
              }
            }
          }

          // trade.Sltp.SlPrice = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_DOWN).toString()
          ref.$store.state.trade.editTrade.Sltp.SlPrice = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_HALF_UP).toString()
          // var slPct = new Decimal(trade.Price).sub(trade.Sltp.SlPrice).div(trade.Price).mul(100).toNumber()
          // console.log('slPct', slPct)
          // console.log('trade.Sltp.SlPrice', ref.$store.state.trade.editTrade.Sltp.SlPrice)
          // if (slPct < 0) {
          //   slPct = -1 * slPct
          // }
          const slPct = ref.returnSlPct(trade)
          this.setText('SL: ' + slPct.toFixed(1) + '%')
        })
        .onModify('onModify called', function (text) {

        })
        .onCancel('onCancel called', function (text) {
          this.remove()
          state.slLine = null
          // console.log('state.slLine', state.slLine)
          ref.$store.state.trade.slAdded = false
          trade.Sltp.SlPrice = '0'
        })
        .setText('SL: ' + plus + slPct + '%')
        .setPrice(parseFloat(trade.Sltp.SlPrice))
        .setQuantity('100% ' + trade.Symbol.split('_')[0])
        .setLineStyle(1)
        .setLineLength(1)
        .setLineWidth(2)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)

      state.slLine = slLine
    },
    addTradeSlLine (trade, retryCount = 0) {
      try {
        this.addTradeSlLineInternal(trade)
      } catch (error) {
        // console.log('Error creating trade SL line, retrying in 1 second')
        if (retryCount < TVRETRY_COUNT) {
          setTimeout(() => {
            this.addTradeSlLine(trade, retryCount + 1)
          }, TVRETRY_DELAY)
        }
      }
    },
    addSlLine () {
      if (!state.tvWidget || !state.tvWidget._ready || !state.tvWidget.chart()) {
        return
      }
      if (!state.buyLine && this.storetrade.type !== 'market') {
        this.addBuyLine()
      }
      const ref = this
      const color = 'rgb(240,26,179)'
      // var color = '#f08080'
      const priceDec = ref.$store.state.data.symbolsfilter[ref.$store.state.trade.symbol].PriceDec
      const mult = this.$store.state.trade.side === 'B' ? 0.99 : 1.01
      if (!ref.$store.state.trade.slprice) {
        ref.$store.state.trade.slprice = new Decimal(ref.$store.state.trade.price).mul(mult).toDP(priceDec, Decimal.ROUND_DOWN).toString()
      }
      let slPct = new Decimal(ref.$store.state.trade.price).sub(ref.$store.state.trade.slprice).div(ref.$store.state.trade.price).mul(100).toNumber()
      if (slPct < 0) {
        slPct = -1 * slPct
      }
      const slLine = state.tvWidget.chart().createOrderLine()
        .onMove(function () {
          // move back incorrect stop loss
          if (ref.$store.state.trade.side === 'B') {
            if (new Decimal(this.getPrice()).greaterThanOrEqualTo(ref.$store.state.trade.price)) {
              this.setPrice(new Decimal(ref.$store.state.trade.price).mul(0.995).toDP(priceDec, Decimal.ROUND_DOWN).toNumber())
            }
          } else {
            if (new Decimal(this.getPrice()).lessThanOrEqualTo(ref.$store.state.trade.price)) {
              this.setPrice(new Decimal(ref.$store.state.trade.price).mul(1.005).toDP(priceDec, Decimal.ROUND_DOWN).toNumber())
            }
          }

          // this.setText('onMove called')
          ref.$store.state.trade.slprice = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_HALF_UP).toString()
          let slPct = new Decimal(ref.$store.state.trade.price).sub(ref.$store.state.trade.slprice).div(ref.$store.state.trade.price).mul(100).toNumber()
          if (slPct < 0) {
            slPct = -1 * slPct
          }
          this.setText('SL: -' + slPct.toFixed(1) + '%')
        })
        .onModify('onModify called', function (text) {
          // this.setText(text)
          // ref.showSltp()
        })
        .onCancel('onCancel called', function (text) {
          // this.setText(text)
          this.remove()
          state.slLine = null
          ref.$store.state.trade.slprice = ''
        })
        // .setText('STOP LOSS: -0.5%')
        .setText('SL: -' + slPct.toFixed(1) + '%')
        .setPrice(parseFloat(ref.$store.state.trade.slprice))
        // .setQuantity(this.$store.state.trade.qty + ' ' + this.$store.state.trade.pair[0])
        .setQuantity('100% ' + this.$store.state.trade.pair[0])
        .setLineStyle(1)
        .setLineLength(1)
        .setLineWidth(2)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)

      state.slLine = slLine
    },
    changeSymbol (symbol) {
      // this.chart.activeChart().resetData()
      // var cc = this.chart.chartsCount()
      // console.log('cc=' + cc)

      // this.showChart = false
      // this.showChart = true
      this.createChart()
    },

    createChart (tvdatastr) {
      // var w = window.innerWidth
      // console.log('CREATE CHART. ref.chartSymbol: ' + this.chartSymbol)
      if (state.tvWidget && state.tvWidget._ready && state.tvWidget.chart() && this.$store.state.trade.tvEnabled && !tvdatastr) {
        state.tvWidget.chart().setSymbol(this.chartSymbol)
      } else {
        const capicoAppTerminalTvInterval = 'capico_app_terminal_tv_interval'
        let interval = localStorage.getItem(capicoAppTerminalTvInterval)
        if (!interval) {
          interval = '60'
        }
        const userId = sha256(this.$store.state.sys.email)
        // var md = new MobileDetect(window.navigator.userAgent)
        const disabledFeatures = ['header_symbol_search', 'timeframes_toolbar', 'header_compare']
        // if (md.mobile()) {
        //   disabledFeatures.push('left_toolbar')
        // }

        const widgetOptions = {
          debug: false,
          symbol: this.chartSymbol,
          datafeed: Datafeed, // our datafeed object
          interval,
          container: this.containerId,
          library_path: '/app/charting_library/',
          custom_css_url: '/app/chart.css',
          locale: this.$store.state.sys.lang,
          timezone: Util.getTimezone(),
          disabled_features: disabledFeatures,
          enabled_features: ['side_toolbar_in_fullscreen_mode'],
          charts_storage_url: process.env.VUE_APP_TV_URL,
          charts_storage_api_version: '1.1',
          client_id: 'capico.app',
          user_id: userId,
          fullscreen: false,
          // allow_symbol_change: false,
          autosize: true,
          studies_overrides: {},
          auto_save_delay: 15,
          load_last_chart: true,
          numeric_formatting: { decimal_sign: '.' },
          favorites: {
            intervals: ['1', '60', '1D'],
            chartTypes: ['Area', 'Candles']
          },
          theme: this.$store.getters.isThemeLight ? 'Light' : 'Dark',
          loading_screen: {
            foregroundColor: Util.getCssVariable('--color-accent'),
            backgroundColor: Util.getCssVariable('--color-chart')
          },
          overrides: {
            // "paneProperties.background": "#404364",
            // "paneProperties.vertGridProperties.color": "#363c4e",
            // "paneProperties.horzGridProperties.color": "#363c4e",
            'symbolWatermarkProperties.transparency': 90,
            // "scalesProperties.textColor": "#AAA",
            // "mainSeriesProperties.candleStyle.wickUpColor": "#336854",
            // "mainSeriesProperties.candleStyle.wickDownColor": "#7f323f",
            'mainSeriesProperties.showCountdown': true,
            'mainSeriesProperties.candleStyle.upColor': '#20b2aa',
            // 'mainSeriesProperties.candleStyle.downColor': '#f08080',
            'mainSeriesProperties.candleStyle.drawBorder': false,
            'paneProperties.vertGridProperties.style': 2,
            'paneProperties.horzGridProperties.style': 2

            // #404364
          }
        }

        // if (tvdatastr) {
        //   // console.log('tvdata applied')
        //   widgetOptions.saved_data = JSON.parse(tvdatastr)
        //   let symbol1 = this.$store.state.bots.symbol.replace('_', '/')
        //   // console.log('this.chartSymbol', this.chartSymbol, symbol1)
        //   if (widgetOptions.saved_data.charts[0].panes[0].sources[0].state.symbol) {
        //     widgetOptions.saved_data.charts[0].panes[0].sources[0].state.symbol = this.chartSymbol
        //     widgetOptions.saved_data.charts[0].panes[0].sources[0].state.shortName = symbol1
        //   }
        // }

        // eslint-disable-next-line
        const tvWidget = new widget(widgetOptions)

        state.tvWidget = tvWidget
        // console.log(window.TradingView.version())

        // enable TV before loading
        // this.$store.state.trade.tvEnabled = true
        // this.$store.state.trade.tvLoading = false

        tvWidget.onChartReady(() => {
          // console.log('tv widget is ready')

          // enable TV after loading
          this.$store.state.trade.tvEnabled = true
          this.$store.state.trade.tvLoading = false

          this.addButtons()
          Util.applyChartOverrides(tvWidget, 'terminal')

          tvWidget.subscribe('onAutoSaveNeeded', () => {
            tvWidget.saveChartToServer(null, (err) => console.log(err), { defaultChartName: 'Auto' })
          })

          const subscrSymb = tvWidget.chart().onSymbolChanged()
          subscrSymb.subscribe(null, () => {
            const newSymbol = tvWidget.chart().symbol().replace('/', '_').split(':')[1]
            // console.log('onSymbolChanged. cur symbol:', this.$store.state.trade.symbol, tvWidget.chart().symbol(), newSymbol)
            this.$store.state.trade.dataLoading = true
            if (this.$store.state.trade.symbol !== newSymbol) {
              // this.$store.state.trade.symbol = newSymbol
              this.$store.state.trade.editTrade = null
            }
          })

          // this.resetExmoInterval = setInterval(() => {
          //   if ($store.state.sys.tradeExchange.ExchId === 'EXM' && this.$route.name === 'terminal') {
          //     // console.log('term reset data for EXMO')
          //     Data.resetCacheTerm()
          //     tvWidget.chart().resetData()
          //   }
          // }, 15000)

          const subscr2 = tvWidget.chart().onIntervalChanged()
          subscr2.subscribe(null, (interval, obj) => {
            // console.log('onIntervalChanged', interval, obj)
            localStorage.setItem(capicoAppTerminalTvInterval, interval)
          })

          this.drawSymbolTPsAndOrders()
          this.drawSymbolExeOrdersArrows()

          // we migrated to high-level loading from old save
          // tvWidget.subscribe('onAutoSaveNeeded', this.saveTVData)

          const subscr = tvWidget.chart().onDataLoaded()
          subscr.subscribe(null, () => {
            // console.log('onDataLoaded')

            this.redrawFilledArrows()

            if (this.$store.state.trade.dataLoading) {
              this.$store.state.trade.dataLoading = false
            } else {
              return
            }

            // console.log('onDataLoaded - in')

            const trade = this.$store.state.trade.editTrade
            if (trade) {
              if (!this.storetrade.showArrors) {
                return
              }

              setTimeout(() => {
                if (trade.Orders) {
                  this.cleanFilledArrows()
                  trade.Orders.forEach(order => {
                    this.addFilledOrderArrowShape(order)
                  })
                }
              }, 10)
            } else {
              this.redrawFilledArrows()
            }
          })
        })
      }
    },
    detectSleepModeWakeUp (interval = 10 * 1000) {
      if (Date.now() - this.lastSample >= interval * 2) {
        if (state.sleepResetTimeout) {
          clearTimeout(state.sleepResetTimeout)
        }
        state.sleepResetTimeout = setTimeout(() => {
          state.sleepResetTimeout = null
          Data.resetCacheTerm()
          if (state.tvWidget && state.tvWidget._ready && state.tvWidget.chart()) {
            state.tvWidget.chart().resetData()
          }
        }, 3000)
      }

      this.lastSample = Date.now()
      if (state.sleepTimeout) {
        clearTimeout(state.sleepTimeout)
      }
      state.sleepTimeout = setTimeout(() => {
        state.sleepTimeout = null
        this.detectSleepModeWakeUp()
      }, interval)
    }
  },
  created () {
    this.detectSleepModeWakeUp()
  },
  mounted () {
    if (this.$store.state.sys.email !== '' & this.$store.state.trade.showTV === true && this.showChart && this.$store.state.trade.tvLoading === false) {
      this.$store.state.trade.tvLoading = true
      this.startChart()
    }
  },
  beforeDestroy () {
    if (state.sleepTimeout) {
      clearTimeout(state.sleepTimeout)
      state.sleepTimeout = null
    }
    if (state.sleepResetTimeout) {
      clearTimeout(state.sleepResetTimeout)
      state.sleepResetTimeout = null
    }
    if (state.buyLine) state.buyLine.remove()
    if (state.slLine) state.slLine.remove()
    if (state.averageBuyLine) state.averageBuyLine.remove()
    if (state.liquidationLine) state.liquidationLine.remove()
    state.tpLines.forEach(line => line.remove())
    state.soLines.forEach(line => line.remove())
    state.soTrailingLines.forEach(line => line.remove())
    state.triggerLines.forEach(line => line.remove())
    state.arrows.forEach(arrow => arrow.remove())
    state.filledArrows.forEach(arrow => arrow.remove())
    global.viewModeLines.forEach(line => line.remove())
    if (state.tvWidget) {
      const oldWidget = state.tvWidget
      state.tvWidget = null
      oldWidget.remove()
    }
  },
  destroyed () {
    state.buyLine = null
    state.slLine = null
    state.averageBuyLine = null
    state.liquidationLine = null
    state.tpLines = []
    state.soLines = []
    state.soTrailingLines = []
    state.triggerLines = []
    state.arrows = []
    state.filledArrows = []
    global.viewModeLines = []
    this.$store.state.trade.tvEnabled = false
    this.$store.state.trade.tvLoading = false
  }
}
</script>
